import validator from "validator";
import message from "../../../messages/ticket";

const validateTitle = (title) => {
  if (validator.isEmpty(title)) {
    return message.ADD_TICKET_TITLE_DOSE_NOT_EXIST;
  }

  if (!title.trim().length) {
    return message.ADD_TICKET_TITLE_DOSE_NOT_EXIST;
  }

  return true;
};

const validateText = (text) => {
  if (validator.isEmpty(text)) {
    return message.ADD_TICKET_TEXT_DOSE_NOT_EXIST;
  }

  if (!text.trim().length) {
    return message.ADD_TICKET_TEXT_DOSE_NOT_EXIST;
  }

  return true;
};

const validateCategoryID = (categoryID) => {
  if (validator.isEmpty(categoryID)) {
    return message.ADD_TICKET_CATEGORY_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(categoryID)) {
    return message.ADD_TICKET_CATEGORY_INVALID;
  }

  return true;
};

const validateFormAddTicket = (data) => {
  const resValidateTitle = validateTitle(data.title);
  if (resValidateTitle != true) {
    return resValidateTitle;
  }

  const resValidateText = validateText(data.text);
  if (resValidateText != true) {
    return resValidateText;
  }

  const resValidateCategoryID = validateCategoryID(data.categoryID);
  if (resValidateCategoryID != true) {
    return resValidateCategoryID;
  }

  return true;
};

export default validateFormAddTicket;
